import { Box, SwipeableDrawer, Typography } from '@mui/material';
import { DrawerProps } from './drawer.interface';
import useDrawerStyles from './drawer.styles';

const Drawer = ({
  title,
  anchor,
  isOpen,
  fitHeight = false,
  children,
  onOpen,
  onClose,
}: DrawerProps) => {
  const { classes } = useDrawerStyles({ fitHeight });

  return (
    <SwipeableDrawer
      anchor={anchor}
      open={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      className={classes.drawer}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <div className={classes.drawerHandler} />
        <Box className={classes.mobileHeader}>
          <Typography variant="h6" align="center">
            {title}
          </Typography>
        </Box>
      </Box>
      {children}
    </SwipeableDrawer>
  );
};

export default Drawer;
